(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ranking"] && !Shopify.designMode) return;
  try {
    
(function() {
  var container = document.querySelector('.ranking__slider-container');
  var slider = document.getElementById('rankingSlider');
  if (!container || !slider) return;

  var items = slider.querySelectorAll('.ranking__item');
  var currentIndex = 0;
  var autoSlideInterval = null;

  function isMobile() {
    return window.innerWidth <= 480;
  }

  function getSlideWidth() {
    if (items[0]) {
      return items[0].offsetWidth + 16;
    }
    return window.innerWidth * 0.5;
  }

  function slideToIndex(index) {
    if (!isMobile()) return;
    currentIndex = index;
    if (currentIndex >= items.length - 1) currentIndex = 0;
    if (currentIndex < 0) currentIndex = items.length - 2;
    var slideWidth = getSlideWidth();
    slider.style.transform = 'translateX(-' + (currentIndex * slideWidth) + 'px)';
  }

  function startAutoSlide() {
    if (autoSlideInterval) clearInterval(autoSlideInterval);
    if (!isMobile()) return;
    autoSlideInterval = setInterval(function() {
      slideToIndex(currentIndex + 1);
    }, 3000);
  }

  function stopAutoSlide() {
    if (autoSlideInterval) {
      clearInterval(autoSlideInterval);
      autoSlideInterval = null;
    }
  }

  function init() {
    if (isMobile()) {
      currentIndex = 0;
      slider.style.transform = 'translateX(0)';
      startAutoSlide();
    } else {
      slider.style.transform = '';
      stopAutoSlide();
    }
  }

  init();

  var resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      init();
    }, 100);
  });

  slider.addEventListener('touchstart', function() {
    stopAutoSlide();
  });

  slider.addEventListener('touchend', function() {
    startAutoSlide();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
